/* eslint-disable you-dont-need-momentjs/is-same */
/* eslint-disable you-dont-need-momentjs/no-moment-constructor */
/* eslint-disable you-dont-need-momentjs/format */
/* eslint-disable no-param-reassign */
import moment from 'moment'
import { combineReducers } from 'redux'

import {
  getCountOfWorkingDays,
  getWeekendDays,
  LAUNCH_TIME_FORMAT,
  WIZARD_DATE_FORMAT,
} from 'utils/dateUtils'

import {
  CAMPAIGN_TYPES_VALUES,
  DELIVERY,
  LEVEL_VALUES,
  PARTICIPANTS_GROUP_KEYS,
} from 'containers/AwarenessCenter/constants'

import {
  CHANGE_CLOSE_TIME,
  CHANGE_DEFAULT_LOCALE_ID,
  CHANGE_END_DATE,
  CHANGE_MAX_EMAIL_PER_DAY,
  CHANGE_PARTICIPANTS_SELECTION,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  GET_CAMPAIGN_ASYNC,
  RESET_CAMPAIGN_TYPE_FLAGS,
  TOGGLE_LANDING_PAGE,
  TOGGLE_RANDOMIZED,
  TOGGLE_SEND_ALL_WEEK,
  TOGGLE_TRAINING_VIDEO,
} from '../steps/constants'
import {
  SPEAR_PHISHING_CAMPAIGN_DATA_POLLING,
  UPDATE_PARTICIPANTS,
} from '../steps/GenerateEmailsStep/constants'
import generateEmailsStepReducer from '../steps/GenerateEmailsStep/reducer'
import landingPageStepReducer from '../steps/LandingPageStep/reducer'
import { wizardHandlers } from '../steps/reduсer'
import reviewAndLaunchStepReducer from '../steps/ReviewAndLaunchStep/reducer'
import { GET_PARTICIPANTS_ASYNC, VALIDATE_SETUP_STEP } from '../steps/SetupStep/constants'
import setupStepReducer from '../steps/SetupStep/reducer'
import {
  AUTOMATED_LEVEL_BASED_TRAINING,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_FILE,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
} from '../steps/TrainingModuleStep/constants'
import trainingModuleStepReducer from '../steps/TrainingModuleStep/reducer'
import {
  getSimulationCampaignLaunchProperties,
  mapSimulationValidatorByName,
} from '../WizardSimulationCampaign/utils'

import {
  CHANGE_IS_FAILED_GENERATED_EMAILS_MODAL_OPEN,
  CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA,
  DEFAULT_SPEAR_PHISHING_CAMPAIGN_OBJECT,
} from './constants'

const handlers = {
  [RESET_CAMPAIGN_TYPE_FLAGS]: (state) => ({
    ...state,
    isQuickLaunch: false,
    editMode: false,
  }),
  [VALIDATE_SETUP_STEP]: (state) => ({
    ...state,
    validation: {
      ...state.validation,
      name: mapSimulationValidatorByName.name(state.campaign.name),
      launchDate: mapSimulationValidatorByName.launchDate(state.campaign.launchDate),
      endDate: mapSimulationValidatorByName.endDate(state.campaign.endDate),
      closeTime: mapSimulationValidatorByName.closeTime(
        state.campaign.closeTime,
        state.campaign.endDate
      ),
      launchTime: mapSimulationValidatorByName.launchTime(
        state.campaign.launchTime,
        state.campaign.launchDate,
        state.campaign.timezone,
        state.campaign.randomized
      ),
    },
  }),
  [CHANGE_MAX_EMAIL_PER_DAY]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      ...getSimulationCampaignLaunchProperties(state, {
        maxEmailPerDay: payload.value,
      }),
    },
  }),
  [CHANGE_END_DATE]: (state, { payload }) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      endDate: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        endDate: mapSimulationValidatorByName.endDate(campaignLaunchProperties.endDate),
      },
    }
  },
  [CHANGE_CLOSE_TIME]: (state, { payload }) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      closeTime: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        closeTime: mapSimulationValidatorByName.closeTime(
          campaignLaunchProperties.closeTime,
          campaignLaunchProperties.endDate
        ),
      },
    }
  },
  [TOGGLE_RANDOMIZED]: (state) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      randomized: !state.campaign.randomized,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchTime: mapSimulationValidatorByName.launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [TOGGLE_SEND_ALL_WEEK]: (state) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      sendAllWeek: !state.campaign.sendAllWeek,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchTime: mapSimulationValidatorByName.launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [TOGGLE_LANDING_PAGE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedLandingPage: payload.selected ? {} : payload.landingPage,
    },
  }),
  [TOGGLE_TRAINING_VIDEO]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo: payload.selected ? [] : [payload.trainingVideo],
    },
  }),
  [GET_CAMPAIGN_ASYNC.SUCCESS]: (state, { payload }) => {
    payload.data.trainings = payload.data.trainings.filter((training) => !training.is_deleted)

    const name = payload.data.name
    const randomized = payload.data.randomized
    const sendAllWeek = payload.data.send_all_week
    const launchDate = moment(payload.data.schedule_time).format(WIZARD_DATE_FORMAT)
    const launchTime = randomized
      ? ''
      : moment(payload.data.schedule_time).format(LAUNCH_TIME_FORMAT)
    let endDate = moment(payload.data.end_date).format(WIZARD_DATE_FORMAT)
    if (!moment(endDate).isValid()) endDate = ''
    const closeTime = moment(payload.data.close_time).format(WIZARD_DATE_FORMAT)
    const timezone = payload.data.campaign_timezone
    let selectedTrainingVideo = []

    if (payload.data.trainings.length) {
      selectedTrainingVideo = payload.data.trainings
      selectedTrainingVideo = selectedTrainingVideo.map((video) => {
        const videoName =
          video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
            ? video.items[0]?.custom_type === CUSTOM_MODULE_TYPES.CUSTOM_VIDEO
              ? CUSTOM_MODULE_NAME_FILE
              : CUSTOM_MODULE_NAME_URL
            : video.name

        return {
          ...video,
          name: videoName,
          vendor: video.vendor || SOURCE_VALUES.CUSTOM_MODULE,
          imagePreview: video.image_preview
            ? video.image_preview
            : !video.vendor
            ? CUSTOM_MODULE_IMAGE_PREVIEW
            : '',
          items: video.items.map((item) => ({
            ...item,
            localeId: item.locale,
            embeddedSubtitles: item.embedded_subtitles,
            customType: item.custom_type,
            imagePreview:
              video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                ? CUSTOM_MODULE_IMAGE_PREVIEW
                : item.image_preview || '',
          })),
        }
      })
    } else {
      selectedTrainingVideo = [AUTOMATED_LEVEL_BASED_TRAINING]
    }

    return {
      ...state,
      campaign: {
        id: payload.data.id,
        participants: {
          ...state.campaign.participants,
          selectorLoader: true,
          included: payload.data.participants_choices || {},
          excluded: payload.data.participants_exclude_choices || {},
        },
        name,
        defaultLocaleId: payload.data.locale,
        isTournament: payload.data.is_tournament,
        timezone,
        maxEmailPerDay: payload.data.max_email_per_day,
        status: payload.data.status,
        launchDate,
        launchTime,
        endDate,
        closeTime,
        sendRemindersUntil: payload.data.sendRemindersUntil,
        sendAllWeek,
        randomized: payload.data.randomized,
        delivery: DELIVERY[payload.data.delivery_type.toUpperCase()],
        sendingDays: getCountOfWorkingDays(
          moment(launchDate),
          moment(endDate),
          sendAllWeek ? [] : getWeekendDays(state.workdays)
        ),
        selectedLandingPage: payload.data.landing_page || {},
        selectedTrainingVideo,
        sendReminderEveryXBusinessDays: payload.data.sendReminderEveryXBusinessDays,
        spearPhishingCampaignData: payload.data.spear_phishing_campaign_data,
        sendCampaignFailedEmail: payload.data.sendCampaignFailedEmail,
        sendCampaignSummaryToCampaignReportRecipients:
          payload.data.sendCampaignSummaryToCampaignReportRecipients,
        notifications: payload.data.notifications,
      },
      validation: {
        ...state.validation,
        name: mapSimulationValidatorByName.name(name),
        launchDate: mapSimulationValidatorByName.launchDate(launchDate),
        endDate: mapSimulationValidatorByName.endDate(endDate),
        launchTime: mapSimulationValidatorByName.launchTime(
          launchTime,
          launchDate,
          timezone,
          randomized
        ),
        closeTime: mapSimulationValidatorByName.closeTime(closeTime, endDate),
      },
    }
  },
  [SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      spearPhishingCampaignData: payload.data.spear_phishing_campaign_data,
    },
  }),
  [GET_PARTICIPANTS_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    loader: false,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        selectorLoader: false,
        modalLoader: false,
        error: null,
        items: payload.data.items,
        meta: {
          awarenessLevels: {
            [LEVEL_VALUES.BEGINNER_LEVEL]: payload.data.meta.awarenessLevels.beginner,
            [LEVEL_VALUES.MID_LEVEL]: payload.data.meta.awarenessLevels.mid,
            [LEVEL_VALUES.EXPERT_LEVEL]: payload.data.meta.awarenessLevels.expert,
          },
          count: payload.data.meta.count,
        },
      },
      ...getSimulationCampaignLaunchProperties(
        state,
        {
          maxEmailPerDay:
            state.campaign.maxEmailPerDay && state.campaign.maxEmailPerDay < payload.data.meta.count
              ? state.campaign.maxEmailPerDay
              : payload.data.meta.count,
          participantsCount: payload.data.meta.count,
        },
        // forceCalculation only if maxEmailPerDay not Unlimited
        !!state.campaign.maxEmailPerDay
      ),
    },
  }),
  [CHANGE_PARTICIPANTS_TOTAL_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (Object.values(payload.data.included).length === 0) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        awarenessLevels: {
          [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
          [LEVEL_VALUES.MID_LEVEL]: 0,
          [LEVEL_VALUES.EXPERT_LEVEL]: 0,
        },
        count: 0,
      }
    } else {
      participantsData.excluded = payload.data.excluded
    }

    participantsData.included = payload.data.included

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        participants: participantsData,
        ...getSimulationCampaignLaunchProperties(
          state,
          {
            maxEmailPerDay:
              state.campaign.maxEmailPerDay &&
              state.campaign.maxEmailPerDay < participantsData.meta.count
                ? state.campaign.maxEmailPerDay
                : participantsData.meta.count,
            participantsCount: participantsData.meta.count,
          },
          // forceCalculation only if maxEmailPerDay not Unlimited
          !!state.campaign.maxEmailPerDay
        ),
      },
    }
  },
  [CHANGE_PARTICIPANTS_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (
      payload.key === PARTICIPANTS_GROUP_KEYS.INCLUDED &&
      Object.values(payload.value).length === 0
    ) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        awarenessLevels: {
          [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
          [LEVEL_VALUES.MID_LEVEL]: 0,
          [LEVEL_VALUES.EXPERT_LEVEL]: 0,
        },
        count: 0,
      }
    }

    participantsData[payload.key] = payload.value

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        participants: participantsData,
        ...getSimulationCampaignLaunchProperties(
          state,
          {
            maxEmailPerDay:
              state.campaign.maxEmailPerDay &&
              state.campaign.maxEmailPerDay < participantsData.meta.count
                ? state.campaign.maxEmailPerDay
                : participantsData.meta.count,
            participantsCount: participantsData.meta.count,
          },
          // forceCalculation only if maxEmailPerDay not Unlimited
          !!state.campaign.maxEmailPerDay
        ),
      },
    }
  },
  [CHANGE_SPEAR_PHISHING_CAMPAIGN_DATA]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      spearPhishingCampaignData: {
        generateScenarios: payload.generateScenarios,
      },
    },
  }),
  [CHANGE_DEFAULT_LOCALE_ID]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      defaultLocaleId: payload.value,
      selectedTrainingVideo: [],
    },
  }),
  [UPDATE_PARTICIPANTS.INITIATE]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      generatedEmailsParticipantsLoader: true,
    },
  }),
  [UPDATE_PARTICIPANTS.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      generatedEmailsParticipants: payload.data.items.map(({ profile, generationStatus }) => ({
        ...profile,
        generationStatus,
      })),
      generatedEmailsParticipantsLoader: false,
    },
  }),
  [UPDATE_PARTICIPANTS.ERROR]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      generatedEmailsParticipantsLoader: false,
    },
  }),
  [CHANGE_IS_FAILED_GENERATED_EMAILS_MODAL_OPEN]: (state, { payload }) => ({
    ...state,
    isFailedGeneratedEmailsModalOpen: payload.value,
  }),
  DEFAULT: (state) => state,
}

export const initialState = {
  loader: false,
  error: null,
  validation: {},

  draftLoader: false,
  draftError: null,
  draftGotManaged: false,

  // workdays: 0 or 1, setting by PUT_WORKDAYS
  editMode: false, // might be changed by INIT_EDIT_MODE
  gotApproved: false, // once BE returning 200 for Approve becomes True and UI making redirect
  maxCampaignsAllowed: undefined,

  isFailedGeneratedEmailsModalOpen: false,

  userProperties: {
    trainingContentVendors: [],
  },

  campaign: { ...DEFAULT_SPEAR_PHISHING_CAMPAIGN_OBJECT },
}

const wizardCampaignReducer =
  () =>
  (state = initialState, action) => {
    const handle = wizardHandlers[action.type] || handlers[action.type] || handlers.DEFAULT

    return handle(state, action, CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING)
  }

export default function () {
  return combineReducers({
    self: wizardCampaignReducer(),
    setupStep: setupStepReducer(),
    generateEmailsStep: generateEmailsStepReducer(),
    landingPageStep: landingPageStepReducer(),
    trainingModuleStep: trainingModuleStepReducer(),
    reviewAndLaunchStep: reviewAndLaunchStepReducer(),
  })
}
